<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <btns class="mgb-20" @exec="exec"></btns>
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="date" label="证件名称"> </el-table-column>
      <el-table-column prop="name" label="文件类型"> </el-table-column>
      <el-table-column prop="address" label="附件">
        <template slot-scope="scope">
          <el-button type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="生效设备">
        <template slot-scope="scope">
          <el-button type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="备注"> </el-table-column>
      <el-table-column prop="address" label="上传时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small">编辑</el-button>
          <el-button type="text" size="small">删除</el-button>
          <el-button type="text" size="small">二维码下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 查看弹框 -->
    <el-dialog
      title="查看附件"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <div class="center">
        <el-image
          style="width: 300px; height: 300px"
          :src="url"
          :preview-src-list="srcList"
        >
        </el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import btns from "@/components/btns.vue";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      url: "",
      srcList: "",
    };
  },
  methods: {
    uploading() {
      this.$router.push("/shebei/photoUploading");
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped></style>
